import { BaseElementWidget, CustomWidget, SPI, ViewType } from '@kunlun/dependencies';
import HintBanner from './HintBanner.vue';

@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Table,
    widget: 'SalesRatioControlHintBanner'
  })
)
export class SalesRatioControlHintBanner extends CustomWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(HintBanner);
    return this;
  }
}
